import React from "react";
import {
  Box,
  Paper,
  List,
  ListSubheader,
  ListItem,
  ListItemText,
} from "@mui/material";
import { H9TitleSmall } from "../../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../../components/StyledComponents/Buttons/AuradineButtons";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export const MinersHashing = React.memo((props) => {
  const { minerHashingData } = props;

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        padding="0.25rem 0.5rem 0.25rem 1rem"
        alignItems={"center"}
      >
        <H9TitleSmall> Miners hashing </H9TitleSmall>
      </Box>
      <>
        <List
          sx={{
            width: "100%",
            backgroundColor: "#EEEDF7",
            borderRadius: "1.5rem",
          }}
        >
          {Object.keys(minerHashingData).length > 0 &&
          minerHashingData.totalHashingDevicesLastHour ? (
            <ListItem>
              <ListItemText>
                {
                  minerHashingData?.totalHashingDevicesLastHour
                }
              </ListItemText>
            </ListItem>
          ) : (
            <ListItem>
              <ListItemText secondary="Miners hashing data unavailable" />
            </ListItem>
          )}
        </List>
      </>
    </Box>
  );
});
